import { FormControl } from '@angular/forms';
import { EntityReference, ProductStockItem } from '../../core/api/api.entities';
import { positiveNotNull, positiveOrZero, requiredNotNull } from '../form-control-options.constants';
import { BaseFormControls } from './base.form-controls';

export abstract class QuickActionFormControls extends BaseFormControls {
  amount = new FormControl(1, positiveNotNull);
  date = new FormControl(new Date(), requiredNotNull);
  stockItem = new FormControl<ProductStockItem | null>(null);
}

export class QuickActionConsumeFormControls extends QuickActionFormControls {
  spoiled = new FormControl(false, requiredNotNull);
}

export class QuickActionOpenFormControls extends QuickActionFormControls {}

export class QuickActionPurchaseFormControls extends QuickActionFormControls {
  bestBeforeDate = new FormControl<Date | null>(new Date());
  neverOverdue = new FormControl(true, requiredNotNull);
  pantIncluded = new FormControl(false, requiredNotNull);
  purchaseQuPant = new FormControl<number | null>(null, positiveOrZero);
  purchaseQuPrice = new FormControl<number | null>(null, positiveOrZero);
  totalDiscount = new FormControl<number | null>(null, positiveOrZero);
}

export class QuickActionTransferFormControls extends QuickActionFormControls {
  override stockItem = new FormControl<ProductStockItem | null>(null, requiredNotNull);
  fromLocation = new FormControl<EntityReference | null>(null, requiredNotNull);
  toLocation = new FormControl<EntityReference | null>(null, requiredNotNull);
}
